// ── BCH Ink — long-form publishing helpers ────────────────────────
//
// BCH Ink is the public-facing brand for BCHNostr's long-form section. It is
// NOT a new content system: articles are the same NIP-23 kind 30023 events
// the "Blog" always used. This module only centralises naming and routing so
// the UX can evolve without touching the data model.
//
// Canonical routes live under /ink. The original /blog routes are kept alive
// as permanent aliases (see App.tsx) so existing shared links, bookmarks and
// indexed URLs never break. New links we generate use /ink.

export const INK_NAME = 'BCH Ink';
export const INK_MARK = '\u2712\uFE0F'; // ✒️
export const INK_TAGLINE = 'Long-form writing from the BCH community.';

/** Canonical base path for BCH Ink routes. */
export const INK_BASE = '/ink';

/** Legacy base path — still resolves to the same articles. */
export const INK_LEGACY_BASE = '/blog';

/** Public origin used when building absolute, shareable article URLs. */
export const INK_ORIGIN = 'https://bchnostr.com';

/**
 * Pick the base path to use for internal links, given the path the user is
 * currently on. If they arrived via a legacy /blog/... link we keep them on
 * /blog so the URL in their address bar stays stable; otherwise we use the
 * canonical /ink. Either way the same article resolves.
 */
export function inkBaseFor(pathname: string): string {
  return pathname.startsWith(INK_LEGACY_BASE) ? INK_LEGACY_BASE : INK_BASE;
}

/** Build an internal route to an article from its naddr. */
export function inkArticlePath(naddr: string, base: string = INK_BASE): string {
  return `${base}/${naddr}`;
}

/** Build the absolute, canonical share URL for an article. */
export function inkArticleUrl(naddr: string): string {
  return `${INK_ORIGIN}${INK_BASE}/${naddr}`;
}
